module.exports = "../dist/img/white-36.c912.jpg";